import {
  EMPLOYEE_CATEGORY_OPTIONS,
  EMPLOYMENT_OPTIONS,
  PAYMENT_TYPE_OPTIONS,
  SALARY_OPTIONS,
} from "model/OrganizationalStructure";
import { SalaryType } from "model/Salary";
import type {
  EmploymentOptions,
  SelectOption,
} from "../../profilePanel.contract";
import {
  STAFF_TAX_TABLE_OPTIONS,
  toTranslatedOptions,
} from "../../../shared/staffPanel.options.logic";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;
const SIMFLEXITY_PAY_PAYMENT_TYPE = "SimflexityPay";

/**
 * Builds translated employment-related dropdown options and applies business rules.
 */
export const toEmploymentOptions = (
  t: TranslateFn,
  isSimflexityEmployee: boolean,
  canSelectSimflexityPay: boolean,
): EmploymentOptions => {
  const employmentOptions: SelectOption[] = toTranslatedOptions(
    EMPLOYMENT_OPTIONS,
    t,
  );

  const salaryOptionsAll: SelectOption[] = toTranslatedOptions(
    SALARY_OPTIONS,
    t,
  );

  const salaryOptions = isSimflexityEmployee
    ? salaryOptionsAll.filter((option) => option.value !== SalaryType.Monthly)
    : salaryOptionsAll;

  const paymentOptionsAll: SelectOption[] = toTranslatedOptions(
    PAYMENT_TYPE_OPTIONS,
    t,
  );

  const paymentOptions = paymentOptionsAll.filter((option) => {
    if (option.value === SIMFLEXITY_PAY_PAYMENT_TYPE) {
      return canSelectSimflexityPay;
    }
    return true;
  });

  const employeeCategoryOptions: SelectOption[] = toTranslatedOptions(
    EMPLOYEE_CATEGORY_OPTIONS,
    t,
  );
  const employeeCategoryLabelByValue = employeeCategoryOptions.reduce<
    Record<string, string>
  >((accumulator, option) => {
    accumulator[option.value] = option.label;
    return accumulator;
  }, {});

  return {
    taxTableOptions: STAFF_TAX_TABLE_OPTIONS,
    employmentOptions,
    salaryOptions,
    paymentOptions,
    employeeCategoryOptions,
    employeeCategoryLabelByValue,
  };
};
